import { OverlayViewF } from '@react-google-maps/api'
import type { MouseEventHandler } from 'react'
import { memo, useCallback, useContext, useEffect, useRef } from 'react'
import styled from 'styled-components'

import SelectedMapItemPin from './Pins/SelectedMapItemPin'
import type { BaseMapElementComponentProps } from '../utils'
import { pinOffSetter } from '../utils'

import Clickable from 'components/Common/Clickable'
import type { ExploreItem, ItemWithOnlyLatLng } from 'tripPlanner/types/common'
import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'

const StyledClickable = styled(Clickable)`
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateX(-50%);
`

interface Props extends BaseMapElementComponentProps {
  item: ItemWithOnlyLatLng | ExploreItem | undefined | null
}

function GooglePOIMarker({
  active,
  item,
  position,
  zIndex,
}: Props) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  const onClick: MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (active) {
        onDeselectMapItem()
      }
    },
    [active, onDeselectMapItem],
  )

  const ref = useRef<HTMLButtonElement | null>(null)

  useEffect(() => {
    if (ref.current && google?.maps) {
      google.maps.OverlayView.preventMapHitsFrom(ref.current)
    }
  }, [ref])

  if (!item) {
    return null
  }

  return (
    <OverlayViewF
      zIndex={active ? 999 : zIndex}
      position={position}
      getPixelPositionOffset={pinOffSetter}
      mapPaneName="overlayMouseTarget"
    >
      <StyledClickable onClick={onClick} ref={ref}>
        {active && <SelectedMapItemPin text="" />}
      </StyledClickable>
    </OverlayViewF>
  )
}

export default memo(GooglePOIMarker)
